<template>
  <div>
    <card>
      <div slot="header" class='toolsBar'>
        <div class="leftTools"> 
          <el-select class="select-default" placeholder="請選擇" v-model="searchForm.column">
            <el-option v-for="i in columnsOptions" class="select-default" :value="i.value" :label="i.text" :key="i.id" />
          </el-select>
          <fg-input type="text" placeholder='' v-model="searchForm.value" />
          <div>
            <l-button type="default" @click="doSearch()">搜尋</l-button>
          </div>
        </div>
        <div>
          <l-button type="info" @click="handlenew()" class='text-right'>新增</l-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column label="貨號">
              <div slot-scope="props">
                <b class="font-weight-light">{{props.row.goodsNumber}}</b>
              </div>
            </el-table-column>
            <el-table-column prop="name" label="名稱" />
            <el-table-column label="包含料號">
              <div class="td-actions" slot-scope="props">
                <template v-for='goodsDetail in props.row.goodsDetails'>
                  <div v-bind:key="goodsDetail.itemNumber"> {{goodsDetail.itemNumber}} <span style='font-size:20px;vertical-align:sub;'>*</span> <b>{{goodsDetail.quantity}}</b></div>
                </template>
              </div>
            </el-table-column>
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs" v-show='props.row.orderGoods.length == 0' @click="handleDelete(props.row.id, props)" >
                  <i class="fa fa-close" style='color:red' />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category" />
        </div>
        <l-pagination class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      @input='handleIndexChange'
                      :total="pagination.total" />
      </div>
    </card>
    <el-dialog
      width="450px"
      center
      :title="getTitle()"
      :visible.sync="modals.custom">
      <fg-input label="貨號"
                type="text"
                name="goodsNumber"
                data-vv-as="貨號"
                v-model="form.goodsNumber"
                v-validate="'required|regex:^[A-Z0-9]{10}$'"
                :disabled="form.id !== ''"      
                :error="getError('goodsNumber')"
                required />
      <fg-input label="名稱"
                type="text"
                name="name"
                data-vv-as="名稱"
                v-model="form.name"
                :error="getError('name')"
                v-validate="'required'"
                required />
      <hr />
      <div>對應料號</div>
      <el-table :data="form.goodsDetails" >
        <el-table-column prop="itemNumber" label="料號">
          <template slot-scope="props">
            <fg-input v-model="props.row.itemNumber" data-vv-as="料號" v-bind:name="`itemNumber${props.$index}`" v-validate="'required'" :error="getError(`itemNumber${props.$index}`)" />
          </template>             
        </el-table-column>
        <el-table-column :min-width="50" prop="quantity" label="數量">
          <template slot-scope="props">
            <fg-input v-model="props.row.quantity" data-vv-as="數量" v-bind:name="`quantity${props.$index}`" type='number' :min='0' :max='10' v-validate="'required|min:1'" :error="getError(`quantity${props.$index}`)"/>
          </template>
        </el-table-column>
        <el-table-column :min-width="30" >
          <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs" slot-scope="props" @click="handleDeleteRow(props.$index)" v-show='form.goodsDetails.length > 1'>
            <i class="fa fa-close" style='color:red' />
          </a>
        </el-table-column>
      </el-table>
      <div style="padding:10px"><l-button type="primary btn-sm" @click="doNewRow()">新增料號</l-button></div>
      <div class="text-right">
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      LPagination
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        form: {
          id: '',
          goodsNumber: '',
          name: '',
          goodsDetails: [{ quantity: 1 }]
        },
        searchForm: {
          value:'',
          column:'goodsNumber',
          
        },
        query: {
          value: '',
          column: ''
        },
        columnsOptions:[
          { value: 'goodsNumber', text: '貨號'},
          { value: 'name', text: '名稱'},
          { value: 'itemNumber', text: '包含料號'}
        ],
        cuser: null,
        modals: {
          custom: false,
          outOfStock: false,
          history: false
        },
        tableData: []
      }
    },
    async mounted() {
      await this.getData()
    },
    watch: {
    },
    computed: {

    },
    methods: {
      getStatusText(row, idx) {
        var status = row.status
        for (var i=0 ; i < this.statusOptions.length ; i++) {
          if (this.statusOptions[i]['status'] == status) {
            return this.statusOptions[i]['text']
          }
        }
        return ''
      },
      doNewRow() {
        this.form.goodsDetails.push({ quantity: 1 })
      },
      getTitle() {
        return (this.form.id == '')?'新增貨號':'編輯貨號'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          if (this.form.id === '') {
            _this.createGoods()
          } else {
            // _this.updateUser(this.form)
          }
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },

      // handleEdit (row) {
      //   this.form.id = row.id
      //   this.form.userName = row.userName
      //   this.form.nickname = row.nickname
      //   this.form.password = ''
      //   this.form.userGroupId = row.userGroupId
      //   this.openModal('custom')
      // },
      doSearch() {
        this.pagination.currentPage = 1
        this.query.column = this.searchForm.column
        this.query.value = this.searchForm.value
        this.getData()
      },
      handleDeleteRow(row) {
        if (this.form.goodsDetails.length == 1) return
        this.form.goodsDetails.splice(row, 1);
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getGoodsList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.goods
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          // console.log('clearForm')
          _this.form.id = ''
          _this.form.name = ''
          _this.form.goodsNumber = ''
          _this.form.note = ''
          resolve()
        })
      },
      async createGoods() {
        var data = await lib.createGoods(this.form)
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } else if (data.status == 7) {
           this.$swal('貨號重複', '', 'error')
        } else if (data.status == 107) {   
           this.$swal('以下料號不存在', data.value.join('<br>'), 'error')
        } else {
          this.$swal('新增失敗', '', 'error')
        }
      },
      async handleDelete(id, porp) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteGoods(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      },
      async handleUpload(id, porp) {
        var result = await tools.confirmDialog(this, `確定要上傳料號?`)
        if (result) {
          var data = await lib.itemUpload(id)
          if (data.status == 0) {
            this.tableData[porp.$index].status = 1
            this.$notify(
            {
              message:`料號 ${porp.row.number} 已上傳`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "danger"
            })
          } else {
            // this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>


<style>
.toolsBar {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}

.leftTools > * {
  padding-right: 10px;
}
</style>
